<template>
  <div>
    <mdb-form-inline class="active-cyan active-cyan-2">
      <mdb-btn color="indigo" @click="startFindingPhoneUserDataFromImport">{{
        $t("find_phone_user_data")
      }}</mdb-btn>
    </mdb-form-inline>
    <InputModal
      :modalShow="phoneSearchModal"
      :dataShow="dataLoadReady"
      :title="$t('find_user_phone_modal_title')"
      :description="$t('find_user_phone_modal_description')"
      :inputLabel="$t('find_user_phone_modal_inputlabel')"
      :buttontext="$t('find_user_phone_modal_button')"
      :dataModal="dataModal"
      v-on:modal-cancelled="phoneSearchCancelled"
      v-on:modal-ok="phoneSearch"
    />
  </div>
</template>

<script>
import { mdbBtn, mdbFormInline } from "mdbvue";
import InputModal from "./InputModal.vue";
export default {
  name: "FindPhoneUserDataFromImport",
  components: {
    mdbBtn,
    mdbFormInline,
    InputModal
  },
  data() {
    return {
      phoneNumber: "",
      filterText: "",
      phoneSearchModal: false,
      dataLoadReady: false,
      dataModal: {
        columns: [
          {
            label: "Id",
            field: "id"
          },
          {
            label: "Puhelinnumero",
            field: "phonenumber"
          },
          {
            label: "Importin nimi",
            field: "name"
          },
          {
            label: "Voimassa",
            field: "lastuntil"
          },
          {
            label: "Luotu",
            field: "created"
          },
          {
            label: "Otettu käyttöön",
            field: "activated"
          },
          {
            label: "Aktiivinen",
            field: "active"
          }
        ],
        rows: null
      },
      retrivebyphonepath: "/1.0/newbe/coupon/retrievebyphonenumberfromimport?sessionid="
    };
  },
  methods: {
    phoneSearchCancelled() {
      this.phoneSearchModal = false;
    },
    phoneSearch(val) {
      this.dataLoadReady = false;
      this.findPhoneUserDataFromImport(val);
    },
    startFindingPhoneUserDataFromImport() {
      this.phoneSearchModal = true;
    },
    findPhoneUserDataFromImport(val) {
      this.$http
        .get(
          this.retrivebyphonepath +
            this.$store.getters.getToken +
            "&phonenumber=" +
            val
        )
        .then(response => {
          if (response.status == 200) {
            this.dataModal.rows = response.data.productcodes;
            this.dataModal.rows.forEach(function(row) {
              row.active =
                row.invalidated === 1 ? "KÄYTÖSSÄ" : "EI KÄYTÖSSÄ";
            });
            this.dataLoadReady = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch(error => {
          return error;
        });
    }
  }
};
</script>

<style scoped>
.active-cyan input[type="text"] {
  border: 1px solid indigo;
  box-shadow: 0 1px 0 0 indigo;
}
</style>
